import { RolesSharedService } from "./../../services/roles-shared.service";
import { Component, OnInit, Inject, ViewChild, OnDestroy, ElementRef } from "@angular/core";
import { FilterUtilService } from "@app/shared/services/filter-util.service";
import { DOCUMENT } from "@angular/common";
import { AuthenticationService } from "@app/shared/services/authentication.service";
import { Router } from "@angular/router";
import swal from "sweetalert2";
import { BreadcrumService } from '@app/shared/services/breadcrum.service';
import { ReportsSort } from "@app/shared/constants/app.constants";
import { Paginator } from "primeng/paginator";
import { NickNameModalService } from "@app/feature/main/roles-shared/services/nick-name-modal.service";
import { CommentModalService } from "@app/shared/services/comment-modal.service";
import * as _ from 'lodash';
import { LikeModalServiceService } from "@app/shared/services/like-modal-service.service";
declare var $: any;
import { Subscription } from "rxjs/Subscription";
import { TechDomainService } from "@app/shared/services/tech-domain.service";
import { debounceTime , distinctUntilChanged, map} from 'rxjs/operators';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { LoaderService } from "@app/shared/services/loader.service";
import { GlobalDataSharedService } from "../../services/global-data-shared-service.service";
@Component({
  selector: "app-reports",
  templateUrl: "./reports.component.html",
  styleUrls: ["./reports.component.css"]
})
export class ReportsComponent implements OnInit, OnDestroy {
  @ViewChild("paginatorId") paginator = new Paginator();
  @ViewChild('searchInput') searchInput : ElementRef;
  @ViewChild('filterInput') filterInput : ElementRef;
  reportsData = [];
  upcomingReportsData = [];
  noReportData: boolean;
  userDetailsObject;
  public now: Date = new Date();
  userRole;
  loggedInStatus;

  techDomainListData: object;
  techDomainListselected = null;
  userId = "";
  sortListData;
  leftMenuExpand = false;
  // search
  searchKeyword = "";
  selectedDomain = "";
  searchString = "";
  sortSelectedindex = null;
  techDomainData;

  // Filter
  totalRecords = 0;
  dataLimit = 9;
  skipValue = 0;
  upcomingSkip = 0;
  filterKeyId: string;

  selectedTab: string;

  noResearchData: boolean;
  shareUrl: string;
  subscription: Subscription;
  isActiveID: string;
  noDataCheck: boolean = false;

  constructor(
    public rolesSharedService: RolesSharedService,
    public filterUtilService: FilterUtilService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private breadcrumService:BreadcrumService,
    private nickNameModalService: NickNameModalService,
    private commentModalService: CommentModalService,
    private likeModalService: LikeModalServiceService,
    @Inject(DOCUMENT) private document: Document,
    private techDomainService: TechDomainService,
    private loaderService: LoaderService,
    private globalDataSharedService: GlobalDataSharedService,
  ) {
    this.document.body.classList.add("inner-page");
    this.document.body.classList.remove("outer-page");
   // window.scroll(0, 0);
  }

  ngOnInit() {

    this.isLoggedIn();
    this.userDetails();
    this.getDomainList();

    this.techDomainListselected = window.localStorage.getItem('selectedTechDomainId') ?
      window.localStorage.getItem('selectedTechDomainId') : null;

    this.tabChange("allReports");
    this.sortListData = ReportsSort.list;
    this.subscription = this.techDomainService.selectedDomainId.subscribe(
      (newSelectedIds) => {
        this.isLoggedIn();
        if (this.loggedInStatus) {
          this.techDomainListselected = newSelectedIds;
          this.applyFilter();
        }
    });
     const tempSession = sessionStorage.getItem('userDetails');
     localStorage.setItem('tempSession',tempSession);
     fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
      // get value
      map((event: any) => {
        return event.target.value;
      })
      // if character length greater then 2
      // ,filter(res => res.length > 2)
      // Time in milliseconds between key events
      ,debounceTime(1000)
      // If previous query is diffent from current
      // ,distinctUntilChanged()
      // subscription for response
      ).subscribe((text: string) => {
        this.searchString = text;
        this.dataLimit = 9;
        if (this.paginator) {
          this.paginator.first = 0;
        }
        if (this.selectedTab === "allReports") {
          this.searchString = text;
          this.skipValue = 0;
          this.reportsData = [];
          this.reportsDataObject();
        } else if (this.selectedTab === "upcoming") {
          this.searchString = text;
          this.upcomingSkip = 0;
          this.upcomingReportsData = [];
          this.getUpComingReports();
        }
      });
      fromEvent(this.filterInput.nativeElement, 'change').pipe(
        // get value
        map((event: any) => {
          return this.techDomainListselected;
          // return event.target.value;
        })
        // if character length greater then 2
        // ,filter(res => res.length > 2)
        // Time in milliseconds between key events
        ,debounceTime(1000)        
        // If previous query is diffent from current   
        ,distinctUntilChanged()
        // subscription for response
        ).subscribe((text: string) => {
          this.filterKeyId = text;
          // this.allResearchData = [];
          this.applyFilter();
        });

        this.globalDataSharedService.getreceivedExpandedFlag().subscribe((param: boolean) => {
          //   console.log('leftMenuExpand param:', param);
             this.leftMenuExpand = param;
         });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    
  }

  isLoggedIn() {
    if (this.authenticationService.isLoggedIn()) {
      this.loggedInStatus = true;
      this.getRole();
    } else {
      this.loggedInStatus = false;
    }
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }

  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.userId = this.userDetailsObject.userId;
    }

    if (this.authenticationService.isLoggedIn()) {
      this.loggedInStatus = true;
      this.getRole();
    } else {
      this.loggedInStatus = false;
    }
  }

  tabChange(tab) {
    if (this.selectedTab !== tab) {
      this.selectedTab = tab;
      this.searchString = "";
      this.sortSelectedindex = null;
      if (this.selectedTab === "allReports") {
        // this.searchInput.nativeElement.value = "";
       this.skipValue = 0;
       this.reportsData = [];
       this.reportsDataObject();
      } else if (this.selectedTab === "upcoming") {
        // this.searchInput.nativeElement.value = "";
       this.upcomingSkip = 0;
       this.upcomingReportsData = [];
       this.getUpComingReports();
      }
    }
  }

  getDomainList() {
    this.rolesSharedService.getTechDomainsList().subscribe(data => {
      this.techDomainListData = data;
    });
  }
  routeTechAnalystProfilePage(analystId: string) {
    this.router.navigate(['analyst-profile'], { queryParams: { analystId: analystId } })
  }
  getHrefAnalystUrl(analystId: string){
   return `${document.location.origin}/#/analyst-profile?analystId=${analystId}`;
  }
  reportsDataFilter() {
    const filter: any = {};
    filter.filter = JSON.stringify({
      include: [
        "users",
        "domains",
        { likes: "user" },
        { comments: "user" },
        { ratings: "user" }
      ]
    });
    filter.limit = this.dataLimit;
    filter.skip = this.skipValue;
    filter.search = this.searchString;
    filter.sort = this.sortSelectedindex ? JSON.stringify(this.sortSelectedindex) : JSON.stringify({ "publishedDate": "DESC" });
    if (this.techDomainListselected) {
      filter.where = JSON.stringify({
        techDomainId: this.techDomainListselected,
        status: "published"
      });
    } else if (!this.techDomainListselected) {
      filter.where = JSON.stringify({
        status: "published"
      });
    }

    return filter;
  }

  upcomingDataFilter() {
    const filter: any = {};
    filter.limit = this.dataLimit;
    filter.skip = this.upcomingSkip;
    filter.search = this.searchString;
    filter.sort = this.sortSelectedindex ? "createdAt " + this.sortSelectedindex.postedDate : "publishedAt DESC";
    if (this.techDomainListselected) {
      filter.techDomainId = this.techDomainListselected;
    } else if (!this.techDomainListselected) {
    }
    return filter;
  }

  getUpComingReports() {
    let searchKey = this.searchString;
    let filterKey = this.filterKeyId;
    this.rolesSharedService.getUpcommingReportsList(this.upcomingDataFilter()).subscribe(
      (response: any) => {
        if ((searchKey === this.searchString) && (filterKey === this.filterKeyId)) {
          this.loaderService.display(false);
        this.upcomingReportsData = _.uniqWith([...this.upcomingReportsData, ...response.data], _.isEqual);
        this.totalRecords = response.totalCount;
        if (this.upcomingReportsData["length"] === 0) {
          this.noReportData = true;
        } else {
         this.noReportData = false;
        }
      }
      },
      error => {
        console.error(error);
      }
    );
  }

  reportsDataObject() {
    let searchKey = this.searchString;
    let filterKey = this.filterKeyId;
    this.rolesSharedService.getReports(this.reportsDataFilter()).subscribe(
      (response: any) => {
        if ((searchKey === this.searchString) && (filterKey === this.filterKeyId)) {
          this.loaderService.display(false);
        this.reportsData = _.uniqWith([...this.reportsData, ...response.data], _.isEqual);
        this.totalRecords = response.totalCount;
        if (this.reportsData["length"] === 0) {
          this.noDataCheck = true;
        } else {
          this.noDataCheck = false;
        }
      }
      },
      error => {
        console.error(error);
      }
    );
  }

  likeClick(postData, index) {
    if (this.loggedInStatus) {
      if (this.userDetailsObject.nickName) {
        let likeObject;
        if (this.selectedTab === "allReports") {
          likeObject = {
            postId: postData.id,
            postType: "report",
            userId: this.userId
          };
        } else if (this.selectedTab === "upcoming") {
          likeObject = {
            postId: postData.id,
            postType: "upcoming_report",
            userId: this.userId
          };
        }
        this.rolesSharedService.addLike(likeObject).subscribe(likeResponse => {
          if (likeResponse["liked"]) {
            // case when user is liked and updated in server
            postData.liked = true;
            postData.likes += 1;
            this.rolesSharedService.logLikeInMixpanel(likeObject.postType, postData.title);
          } else if (!likeResponse["liked"]) {
            // case when user is not liked and updated in server
            postData.liked = false;
            if (postData.likes != 0) {
              postData.likes -= 1;
            }
          }
        });
      } else {
        this.nickNameModalService.openNickNameModal();
        this.nickNameModalService.nickNameDataUpdatedObservable.subscribe(
          (response: any) => {
            if (response) {
              this.userDetails();
            }
          }
        );
      }
    } else {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  openCommentModal(data) {
    if (this.selectedTab === "upcoming") {
      data.postType = "upcoming_report";
    }
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null" && this.loggedInStatus) {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      if (this.loggedInStatus && this.userDetailsObject.nickName) {
        this.commentModalService.modalStatus(true, data);
      } else {
        this.nickNameModalService.openNickNameModal();
      }
    } else {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  populateComments(data) {
    if (this.selectedTab === "upcoming") {
      data.postType = "upcoming_report";
    }
    if (this.loggedInStatus) {
      if (this.userDetailsObject.nickName) {
        data.showComments = !data.showComments;
        this.isActiveID = data.id;
      } else {
        this.nickNameModalService.openNickNameModal();
        this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
          if (response) {
            this.userDetails();
          }
        });
      }
    } else {
      this.router.navigate(["/signin"]);
    }
  }

  openLikeModal(data) {
    if(window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null"){
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      if (this.loggedInStatus) {
        this.likeModalService.modalStatus(true, data);
      }
    }
  }

  applyFilter() {
    this.dataLimit = 9;
    if (this.paginator) {
      this.paginator.first = 0;
    }
    if (this.selectedTab === "allReports") {
      this.skipValue = 0;
      this.reportsData = [];
      this.reportsDataObject();
    } else if (this.selectedTab === "upcoming") {
      this.upcomingSkip = 0;
      this.upcomingReportsData = [];
      this.getUpComingReports();
    }

  }
  onScrollDown() {
    if (this.paginator) {
      this.paginator.first = 0;
    }
    if (this.selectedTab === "allReports") {
      this.skipValue = this.skipValue + 9;
      if(this.totalRecords > this.skipValue) {
        this.reportsDataObject();
      }
    }
  }

  onUpcomingScrollDown() {
    if (this.paginator) {
      this.paginator.first = 0;
    }
    if (this.selectedTab === "upcoming") {
      this.upcomingSkip = this.upcomingSkip + 9;
      this.getUpComingReports();
    }
  }

  paginate(event: any) {
    this.dataLimit = event.rows;
    this.skipValue = event.first;
    this.reportsDataObject();
  }

  isAccessible(id: string, title: string, isPaid: boolean, amount: number) {

    this.breadcrumService.setUrl('BC3Label',title);
    if (this.loggedInStatus) {
      if (this.userRole === "tech-analyst") {
        this.router.navigate([`${this.userRole}/reports/report-details/${id}`]);
      } else {
        this.router.navigate([`${this.userRole}/report-details/${id}`]);
      }
    } else if (!this.loggedInStatus) {
      // fix reditect login
      localStorage.removeItem("REDIRECT_URL");
      localStorage.setItem('REPORT_URL', `/report-details/${id}`)
      this.router.navigate(["/signin"]);
    }
  }

  getHrefUrl(id: string, title: string, isPaid: boolean, amount: number) {
    if (this.loggedInStatus) {
      if (this.userRole === "tech-analyst") {
        return `${document.location.origin}/#/${this.userRole}/reports/report-details/${id}`;
      } else {
        return `${document.location.origin}/#/${this.userRole}/report-details/${id}`;
      }
    } else if (!this.loggedInStatus) {
      // fix reditect login
      return `${document.location.origin}/#/signin`;
    }
  }

  // showPrompt(amount,id) {
  //   swal({
  //     title: "Hold on please",
  //     text: `This report costs 50 SGD. You can either use your existing tokens or buy new tokens to purchase this report. Would you like to proceed ?`,
  //     type: "question",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#3085d6",
  //     confirmButtonText: "Oh sure",
  //     cancelButtonText: "May be later",
  //     confirmButtonClass: "btn btn-sm adjust-swal-button",
  //     cancelButtonClass: "btn btn-sm adjust-swal-button",
  //     buttonsStyling: false
  //   }).then(result => {
  //     if (result.value) {
  //     this.getPaidReportTokenDetails(id);
  //     }
  //   });
  // }
  // displayShareModal(data) {
  //   this.shareUrl = `${document.location.origin}/#/link?type=report&id=${data.id}` ;
  //   $("#share-modal").modal("show");
  // }
  // closeShareModal(){
  //   $("#share-modal").modal("hide");
  // }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/reports/reports.component.ts